const styles = theme => ({
  root: {},
  codeBlock: {
    background: '#F4F6F8',
    borderRadius: 6,
    padding: 16,
    overflowX: 'auto',
    fontFamily: 'inherit',
    fontSize: 14,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    whiteSpace: 'pre-line',
    wordBreak: 'break-all',
  },
  textField: {
    marginBottom: theme.spacing(1),
  },
  button: {
    marginTop: theme.spacing(1),
    width: '100%',
  },
  codeText: {
    maxHeight: '90px',
    overflowX: 'auto',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
  },
})

export default styles
